<template>
    <v-row
            v-if="field.is_visible"
            class="ma-4"
            dense>
        <v-col
                v-if="showDescriptionColumn"
                dense
                cols="12"
                lg="6"
                align-self="center"
                class="ma-0 py-0">
            <span
                    v-if="field.title"
                    class="subtitle-2">{{ field.title }}</span><br>
            <span
                    v-if="field.description"
                    class="caption">
                {{ field.description }}
            </span>
        </v-col>
        <v-col
                cols="12"
                :lg="showDescriptionColumn ? 6 : 12"
                align-self="center"
                class="ma-0 py-0">
            <component
                    :is="loadFieldComponent(field.type)"
                    ref="fieldContent"
                    :field="field"
                    :consumer="consumer"
                    @updateValue="updateValue"
                    @loading="loading" />
        </v-col>
    </v-row>
</template>

<script>
    import FieldTextComponent from "./components/FieldTextComponent";
    import FieldCheckboxComponent from "./components/FieldCheckboxComponent";
    import FieldSignatureComponent from "./components/FieldSignatureComponent";
    import FieldHtmlComponent from "./components/FieldHtmlComponent";
    import FieldDatetimeComponent from "./components/FieldDatetimeComponent";
    import FieldPhotoComponent from "./components/FieldPhotoComponent";
    import FieldDrawingComponent from "@/views/Form/components/components/components/FieldDrawingComponent";
    import Field, {TYPE_CHARGE_AMOUNT, TYPE_DRAWING} from "@/models/field.model"
    import {
        TYPE_SELECT,
        TYPE_TEXT,
        TYPE_TEXTAREA,
        TYPE_CHECKBOX,
        TYPE_PHOTO,
        TYPE_SIGNATURE,
        TYPE_DATETIME,
        TYPE_HTML,
        TYPE_PAYMENT_METHOD,
        TYPE_TIPS
    } from "@/models/field.model"
    import FieldTextareaComponent from "./components/FieldTextareaComponent";
    import FieldSelectComponent from "@/views/Form/components/components/components/FieldSelectComponent";
    import FieldPaymentMethodComponent from "@/views/Form/components/components/components/FieldPaymentMethodComponent";
    import FieldTipsComponent from "@/views/Form/components/components/components/FieldTipsComponent";
    import FieldChargeAmountComponent
        from "@/views/Form/components/components/components/FieldChargeAmountComponent.vue";

    export default {
        name: "FieldComponent",
        components: {
            FieldSelectComponent,
            FieldTextareaComponent,
            FieldTextComponent,
            FieldCheckboxComponent,
            FieldSignatureComponent,
            FieldHtmlComponent,
            FieldDatetimeComponent,
            FieldPhotoComponent,
            FieldDrawingComponent,
            FieldChargeAmountComponent
        },
        props: {
            field: {type: Object, default: () => new Field()},
            consumer: {type: Object, default: () => {}}
        },
        computed: {
            showDescriptionColumn() {
                return this.field.type !== TYPE_SIGNATURE
                    && this.field.type !== TYPE_HTML
            }
        },
        methods: {
            loading: function (value) {
                this.$emit('loading', value)
            },
            loadFieldComponent(type) {
                switch (type) {
                case TYPE_TEXT:
                    return FieldTextComponent;
                case TYPE_TEXTAREA:
                    return FieldTextareaComponent;
                case TYPE_CHECKBOX:
                    return FieldCheckboxComponent;
                case TYPE_SELECT:
                    return FieldSelectComponent;
                case TYPE_SIGNATURE:
                    return FieldSignatureComponent;
                case TYPE_HTML:
                    return FieldHtmlComponent;
                case TYPE_DATETIME:
                    return FieldDatetimeComponent;
                case TYPE_PHOTO:
                    return FieldPhotoComponent;
                case TYPE_DRAWING:
                    return FieldDrawingComponent;
                case TYPE_PAYMENT_METHOD:
                    return FieldPaymentMethodComponent;
                case TYPE_TIPS:
                    return FieldTipsComponent;
                case TYPE_CHARGE_AMOUNT:
                    return FieldChargeAmountComponent;
                default:
                    return null;
                }
            },
            updateValue: function (value) {
                this.$emit('updateValue', this.field.id, value);
            },
            async validate() {
                if (this.field.is_visible) {
                    const value = await this.$refs.fieldContent.getValue();
                    if (!value.isValid) {
                        throw new Error(this.field.title + ' : ' + value.error)
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>